module.exports = __webpack_public_path__ + "static/media/Others_Black.6bb91844.webp";